import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { searchProducts } from '../redux/actions/searchActions';
import { WrapItem, Center, Box, Wrap,Text } from '@chakra-ui/react';
import ProductCard from '../components/ProductCard';
import { useParams } from 'react-router-dom';

const SearchScreen = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [autoComplete,setAutoComplete]=useState([])
    const [searchValue, setSearchValue] = useState(localStorage.getItem('searchValue') || "");
    const dispatch = useDispatch();
    const { loading, error, searchResults } = useSelector((state) => state.search); 
    const { id } = useParams();

    console.log(searchResults)
  const handleSearch = (searchValue) => {
        dispatch(searchProducts(searchValue));
        // Átadott érték beállítása
        setSearchTerm(searchValue);
    };

    useEffect(() => {
        const storedSearchValue = localStorage.getItem('searchValue');
        if (storedSearchValue !== searchValue) {
            setSearchValue(storedSearchValue || "");
        }
    }, []);

    return (
        <Box my={5}>
             <Box style={{textAlign:'center'}} display='flex' justifyContent='center' marginY='20px'>
            <Text fontSize='4xl' fontWeight='bold'><Text> Keresési eredmények: '{id}'</Text></Text>



            </Box>
            {loading && <div>Loading...</div>}
            {error && <div>{error}</div>}
            {searchResults && (
             <Box>
             <Wrap spacing={{base:'20px',md:'30px'}}  justify='center' minHeight='80vh' mx={{ base: '3', md: '20', lg: '32' }}>
                    {searchResults.map((product) => (
                        <WrapItem key={product._id}>
                        <Center>
                            <ProductCard product={product} loading={loading} />
                        </Center>
                    </WrapItem>
                    ))}
                </Wrap>
                </Box>
            )}
        </Box>
    );
};

export default SearchScreen;
